export default {
  title: 'Datos de comprobante',
  invoice_form: {
    info_label: 'Ingresa la siguiente información para la generación de tu comprobante.',
    warning_label:
      'En caso de que no desees datos del comprobante, se generará un comprobante como consumidor final.',
    input_nit: {
      label: 'DUI:',
      placeholder: 'Ingresa un DUI',
      error: {
        required: 'El campo DUI es requerido',
        format: 'Debe especificar un DUI válido'
      }
    },
    input_second_nit: {
      label: 'NIT:',
      placeholder: 'Ingresa un NIT',
      error: {
        required: 'El campo NIT es requerido',
        format: 'Debe especificar un NIT válido'
      }
    },
    input_address: {
      label: 'Dirección de comprobante:',
      placeholder: 'Ingresa la dirección de comprobante',
      error: {
        length: 'Su dirección debe de contener máximo 200 caracteres'
      }
    },
    input_email: {
      label: 'Correo electrónico para tu comprobante:',
      placeholder: 'Ingresa tu correo',
      error: {
        format: 'Debe especificar un correo electrónico válido',
        domain: 'Debe especificar un correo @gmail.com, @hotmail.com, @msn.com o @outlook.com'
      }
    }
  },
  radio_buttons: {
    yes_invoice: 'Deseo recibir mi comprobante por correo electrónico (opcional).',
    no_invoice: 'No deseo comprobante'
  }
}
